<template>
    <v-app>
        <header-component>
        </header-component>

        <template>
            <v-overlay :value="sending" z-index="10000">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
                <span class="loading">処理中です...</span>
            </v-overlay>
            <v-app-bar color="white" flat height="60" app>
                <v-toolbar-title>
                    <h2>
                        <slot name="title"></slot>
                    </h2>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-checkbox v-if="this.isAuthorizer" hide-details v-model="displaySetting.showOtherInputs" @change="changeShowOtherInputs" :label="`他の関係者の入力項目を表示`"></v-checkbox>
                <v-btn class="ms-2 white--text" color="orange" @click="transfer" v-if="this.canTransfer == 1 && !this.isAuthorizer">転送する</v-btn>
                <v-btn class="ms-2 white--text" color="blue-grey" @click="confirmRejectDialog = true" v-if="this.isAuthorizer">却下する</v-btn>
                <v-btn class="ms-2 white--text" color="blue-grey" @click="confirmRejectDialog = true" v-else="this.isAuthorizer">同意せずに却下する</v-btn>
            </v-app-bar>

            <template v-if="!isEnableMeet">
                <v-navigation-drawer :permanent="true" :width=270 :app="true">
                    <v-subheader >
                        <slot name="subheader"></slot>
                    </v-subheader>

                    <!-- メニューをslotで読み込む -->
                    <slot name="step_menu"></slot>
                    <sign-input-navigation-component :pdfs="pdfs" :inputs="stateInputs" ref="nav" @inputFocus="inputFocus"></sign-input-navigation-component>
                </v-navigation-drawer>
            </template>
            <template v-else>
                <v-navigation-drawer :permanent="true" :width=360 :app="true">
                    <v-subheader >
                        <slot name="subheader"></slot>
                    </v-subheader>

                    <div>
                        <div id="meet"></div>
                    </div>
                    <!-- メニューをslotで読み込む -->
                    <slot name="step_menu"></slot>
                    <sign-input-navigation-component :pdfs="pdfs" :inputs="stateInputs" ref="nav" @inputFocus="inputFocus"></sign-input-navigation-component>
                </v-navigation-drawer>
            </template>
        </template>

        <!-- アプリケーションのコンポーネントに基づいてコンテンツのサイズを決定 -->
        <v-main class="my-1" :app="true">
            <sign-input-component
                :registered-inputs="stateInputs"
                :other-inputs="otherInputs"
                :destinations="destinations"
                :pdfs="pdfs"
                agreement-obj-id="uid"
                :max-obj-id="maxObjId"
                :user-id="userId"
                :destination-id="destinationId"
                :is-authorizer="isAuthorizer"
                access-code="accessCode"
                hash="hash"
                @updateInput="updateInput"
                ref="signInput"
                :showOtherInputs="isAuthorizer && displaySetting.showOtherInputs"
                >
            </sign-input-component>
            <!-- アプリケーションに適切なgutterを提供します -->
            <!--<v-container fluid> -->
            <!-- vue-routerを使用している場合 -->
            <!--</v-container>-->

            <!-- メッセージ -->
            <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>

            <!-- 却下確認ダイアログ -->
            <v-dialog v-model="confirmRejectDialog" :dialog.sync="confirmRejectDialog" width="60%">
                <validation-observer ref="observer" v-slot="{ invalid }" >
                    <v-card color="#F4FEFB">
                        <v-container class="py-6">
                            <v-row  justify="center">
                                <div class="justify-center text-h4">
                                    この契約を却下しますか？<br>
                                    ※送信者、確認依頼メールが届いた受信者の却下フォルダに入ります。
                                </div>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <badge-component tile content="任 意">
                                        <label-component horizontal="left">■却下理由</label-component>
                                    </badge-component>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <validation-provider v-slot="{ errors }" name="transferReason" rules="max:10000">
                                        <v-textarea auto-grow outlined v-disabled-icon-focus clearable rows="3" :placeholder="messagePlaceholder" v-model="rejection_reason" background-color="white"></v-textarea>
                                    </validation-provider>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="2">
                                    <v-btn block color="white" v-on:click="confirmRejectDialog = false">キャンセル</v-btn>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn block color="red" class="white--text" :disabled="invalid" v-on:click="reject">却下する</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </validation-observer>
            </v-dialog>
        </v-main>

        <footer-component>
        </footer-component>
    </v-app>
</template>

<script>
  export default {
    props: [
        'user', 'canTransfer', 'isAuthorizer',
        'inputs', 'pdfs',
        'destinations', 'agreementObjId', 'registeredInputs', 'maxObjId', 'userId', 'destinationId', 'accessCode', 'hash',
        'otherInputs', 
    ],
    // props: {
    //     user: Object,
    //     canTransfer: Number,
    //     destinations: Object, pdfs: Object, agreementObjId, registeredInputs: Object, maxObjId, destinationId, accessCode, hash,
    // },
    data: () => ({
        errors: null,
        success: true,
        items: [
            // { title: 'アカウント', href: '' },
            { title: 'ログアウト', href: '/documents/logout' },
        ],
        rejection_reason: "",
        messagePlaceholder: '送信者、確認メールが届いている受信者に通知されます。',
        confirmRejectDialog: false,
        sending: false,
        message: {
            success: false,
            text: '',
        },
        isEnableMeet: false,
        displaySetting: {
            showOtherInputs: false,
        },
    }),
    created(){
        let displaySetting = JSON.parse(window.localStorage.getItem('workflow_display_setting'));
        if (displaySetting){
            this.displaySetting = Object.assign(this.displaySetting, displaySetting);
        }
    },
    computed: {
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
        stateInputs: {
            get: function() {
                return this.inputs;
            },
            set: function(value) {
                this.$emit('inputsUpdate', value);
            }
        },
    },
    methods: {
        // 転送
        transfer: function () {
            axios.post('save-inputs', {
                'inputs': this.inputs
            }).then(res => {
                if (res.data.success) {
                    window.location = "transfer";
                } else {
                    this.message.success = false;
                    this.message.text = res.data.message;
                }
            }).catch(res => {
                this.message.success = false;
                this.message.text = "処理に失敗しました";
            });
        },
        // 却下
        reject: async function () {
            let result = true;
            var self = this;
            this.sending = true;
            try {
                await window.axios
                    .post('reject', {
                        'rejection_reason': self.rejection_reason,
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            result = true;
                            window.location = "reject";
                        }
                        else {
                            result = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "保存処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        result = false;
                        console.log(response);
                        self.message.text = "保存処理に失敗しました";
                        self.message.success = false;
                    }
                );
                self.message.success = result;
            }
            finally {
                this.sending = false;
            }
        },
        // 入力項目の変更
        updateInput: function (inputs) {
            this.stateInputs = inputs;
            this.$refs.nav.inputUpdate(inputs);
        },
        inputFocus: function (item) {
            // let objInput = Object.entries(this.inputs);
            // let objNum = Object.entries(objInput[0][1]);
            // this.$refs.signInput.inputFocus(objInput[0][0], objNum[0][0], item);
            this.$refs.signInput.inputFocus(item.fileId, item.inputItem[1].page_number, item.inputItem);
        },
        loadJitsiScript (cb) {
            const scriptEl = document.createElement('script');
            scriptEl.src = "https://m2.valtec.co.jp/external_api.js";
            scriptEl.async = 1;
            document.querySelector('head').appendChild(scriptEl);
            scriptEl.addEventListener('load', cb);
        },
        embedJitsiWidget () {
            // /var/www/src/resources/js/components/layout/SignLayoutComponent.vueと共通
            const rname = this.destinations[0]["agreement_id"];
            const domain = "m2.valtec.co.jp";
            const options = {
                roomName: rname,
                width: 350,
                height: 400,
                parentNode: document.querySelector("#meet"),
                lang: 'ja',
                configOverwrite: { disableDeepLinking: true},
                interfaceConfigOverwrite: { TOOLBAR_BUTTONS: ["microphone","camera","desktop","hangup", 'participants-pane',"fullscreen"] }
            };
            //オブジェクト確認用 console.log(this.destinations);
            const api = new window.JitsiMeetExternalAPI(domain, options);
        },
        changeShowOtherInputs(item) {
            window.localStorage.setItem('workflow_display_setting', JSON.stringify(this.displaySetting))
        }
    },
    // ビデオ会議追加
    mounted() {
        if (this.destinations[0]["destination_company_name"] == "株式会社バルテック") {
            this.isEnableMeet = true;
            this.loadJitsiScript(() => {
                if (!window.JitsiMeetExternalAPI) throw new Error('Jitsi Meet API not loaded');
                this.embedJitsiWidget();
            });
        }
    }
  };
</script>
